import { formatDate } from "@/lib/helpers/date";
import {
  ClientStatusReferralEnum,
  type ClientReferralByFiltersQuery,
} from "@/__generated__/graphql";
import { ReferralHistoryItem } from "./types";

type ClientReferralItem =
  ClientReferralByFiltersQuery["clientReferralByFilters"]["clientReferrals"][number];

export const getReferralTitle = (
  name: string,
  status: ClientStatusReferralEnum,
) => {
  const maskedName = name.substring(0, 2) + "***";
  const statusText =
    status === ClientStatusReferralEnum.Paid ? "completed" : "pending";
  return `${maskedName} ${statusText} booking`;
};

export const mapClientReferrals = (
  clientReferrals: ClientReferralItem[],
): ReferralHistoryItem[] => {
  if (!clientReferrals?.length) return [];

  return clientReferrals.map((referral) => ({
    id: referral.id,
    title: referral.referredName || "",
    date: referral.package?.createdAt
      ? formatDate(new Date(referral.package.createdAt), "d MMM yyyy, hh:mm")
      : "",
    amount: referral.referralValue || 0,
    status: referral.status ?? ClientStatusReferralEnum.Pending,
  }));
};
